var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 0V1.66667H10.8333V0H12.5V1.66667H15.8333C16.2936 1.66667 16.6667 2.03977 16.6667 2.5V15.8333C16.6667 16.2936 16.2936 16.6667 15.8333 16.6667H0.833333C0.3731 16.6667 0 16.2936 0 15.8333V2.5C0 2.03977 0.3731 1.66667 0.833333 1.66667H4.16667V0H5.83333ZM15 8.33333H1.66667V15H15V8.33333ZM4.16667 3.33333H1.66667V6.66667H15V3.33333H12.5V5H10.8333V3.33333H5.83333V5H4.16667V3.33333Z",
    fill: "url(#paint0_linear_115_4746)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 0V1.66667V3.33333V5H4.16667V3.33333V1.66667V0H5.83333ZM10.8333 3.33333V5H12.5V3.33333V1.66667V0H10.8333V1.66667V3.33333Z",
    fill: "url(#paint1_linear_115_4746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_4746",
    x1: 0,
    y1: 8.33333,
    x2: 16.6667,
    y2: 8.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_4746",
    x1: 0,
    y1: 8.33333,
    x2: 16.6667,
    y2: 8.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.93271ec97c0fd7c4709aa0f7be47a1e3.svg";
export { ForwardRef as ReactComponent };